export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-file.vue?vue&type=template&id=77f0177a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-file/lk-file.vue?vue&type=template&id=77f0177a&
// module id = 1116
// module chunks = 0